export default {
  translation: {
    header: {
      studio: '1PersonStudio',
      title: 'Closer Ties',
    },
    modal: {
      add: 'Комментарий',
      send: 'Отправить',
      cancel: 'Отменить',
      name: 'Имя',
      message: 'Комментарий',
    },
  },
};
